import React from "react";
import InfoIcon from "../../../Assets/images/icon-info-circle.svg";

const SafetyScoreInfo = (props: any) => {
    return (
        <>
            <div className="dialog-header flex">
                <div className="dialog-icon status-default flex justify-center align-items-center">
                    <img src={InfoIcon} alt="Circle with the letter 'i' in the center, signifying information" />
                </div>
            </div>
            <div className="box-title-text">
                <h2 className="box-title breach-dialog-title" style={{ paddingLeft: "0.5rem", paddingTop: 0 }}>
                    About the ID Safety Score
                </h2>
            </div>
            <div className="dialog-body">
                <div className="row">
                    <div className="col-xs-12">
                        <p className="risk-rating-description f-14">
                            Your ID Safety Score summarizes the safety of your digital identity, like how a credit score summarizes your financial health. It’s
                            based on all breaches known to have exposed your information. To improve your score and to further protect yourself from identity crime
                            use our personalized action recommendations.
                        </p>
                    </div>
                </div>
                <div className="row col-xs-12">
                    <div className="risk-rating-title f-14 fw-bold">Score Ranges:</div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <div className="risk-rating-title f-14 fw-bold">Least Protected (0—49)</div>
                        <p className="risk-rating-description f-14">This range means you have a high risk of identity crime.</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <div className="risk-rating-title f-14 fw-bold">Slightly Protected (50—89)</div>
                        <p className="risk-rating-description f-14">This range means you have a moderate risk of identity crime.</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-8 col-sm-10">
                        <div className="risk-rating-title f-14 fw-bold">Most Protected (90—100)</div>
                        <p className="risk-rating-description f-14">
                            This range means you have a low risk of identity crime. Please keep in mind that this range does not mean you're completely safe from
                            identity crime.
                        </p>
                    </div>
                </div>
            </div>
            <div className="dialog-footer" style={{ padding: 0 }}>
                <div className="row">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button style={{ paddingLeft: "0.25rem" }} type="button" className="btn-default btn-link" onClick={props.closeDialog}>
                            <span className="btn-text">Close</span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SafetyScoreInfo;
